/* eslint-disable no-param-reassign */
import axios from 'axios';
import {axiosMaker, errorMessage} from '../utils/utils';
import * as identificationTypeActions from './types/identificationTypes';
import store from '../store';

export const filterIdentificationTypes = (page, rowsPerPage, order, orderBy, searchText) => async (dispatch) => {
  if (searchText !== '' && store.getState().identificationTypes.searchText !== searchText) {
    page = 0;
  }
  if (order !== store.getState().identificationTypes.order || orderBy !== store.getState().identificationTypes.orderBy) {
    page = 0;
  }
  if (searchText === null) {
    searchText = '';
  }
  dispatch({
    type: identificationTypeActions.FILTER_IDENTIFICATION_TYPES_SENDING,
    payload: {
      identificationTypes: [],
      dataLength: 0,
      page,
      rowsPerPage,
      order,
      orderBy,
      searchText
    }
  });
  try {
    let filter = {};
    if (page !== null && rowsPerPage !== null && order !== null && orderBy !== null && searchText !== null) {
      filter = {
        filters: {
          name: searchText
        },
        operator: 'or',
        page,
        limit: rowsPerPage,
        sort: {
          [orderBy]: order
        }
      };
    }
    const response = await axios(axiosMaker('POST', 'identificationTypes/filter', filter, true));
    return dispatch({
      type: identificationTypeActions.FILTER_IDENTIFICATION_TYPES_SUCCESS,
      payload: {
        identificationTypes: response.data.results,
        dataLength: response.data.total
      }
    });
  } catch (e) {
    const error = e.response;

    return dispatch({
      type: identificationTypeActions.FILTER_IDENTIFICATION_TYPES_FAILED,
      payload: {
        error,
        message: errorMessage(error)
      }
    });
  }
};

export const getIdentificationTypes = () => async (dispatch) => {
  dispatch({
    type: identificationTypeActions.GET_IDENTIFICATION_TYPES_SENDING,
    payload: {
      identificationTypes: [],
      dataLength: 0
    }
  });
  try {
    const response = await axios(axiosMaker('GET', 'identificationTypes', null, true));
    return dispatch({
      type: identificationTypeActions.GET_IDENTIFICATION_TYPES_SUCCESS,
      payload: {
        identificationTypes: response.data.results,
        dataLength: response.data.results.length
      }
    });
  } catch (e) {
    const error = e.response;

    return dispatch({
      type: identificationTypeActions.GET_IDENTIFICATION_TYPES_FAILED,
      payload: {
        error,
        message: errorMessage(error)
      }
    });
  }
};

export const createIdentificationType = data => async (dispatch) => {
  dispatch({
    type: identificationTypeActions.CREATE_IDENTIFICATION_TYPE_SENDING,
    payload: {}
  });
  try {
    await axios(axiosMaker('POST', 'identificationTypes', data, true));
    return dispatch({
      type: identificationTypeActions.CREATE_IDENTIFICATION_TYPE_SUCCESS,
      payload: {}
    });
  } catch (e) {
    const error = e.response;
    return dispatch({
      type: identificationTypeActions.CREATE_IDENTIFICATION_TYPE_FAILED,
      payload: {
        error,
        message: errorMessage(error)
      }
    });
  }
};

export const updateIdentificationType = (id, identificationType) => async (dispatch) => {
  dispatch({
    type: identificationTypeActions.UPDATE_IDENTIFICATION_TYPE_SENDING,
    payload: {}
  });
  try {
    await axios(axiosMaker('PATCH', `identificationTypes/${id}`, identificationType, true));
    return dispatch({
      type: identificationTypeActions.UPDATE_IDENTIFICATION_TYPE_SUCCESS,
      payload: {}
    });
  } catch (e) {
    const error = e.response;

    return dispatch({
      type: identificationTypeActions.UPDATE_IDENTIFICATION_TYPE_FAILED,
      payload: {
        error,
        message: errorMessage(error)
      }
    });
  }
};
